import React, {useEffect, useState} from 'react';
import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-52LWWVMNHE";
const cookie_consent_variable_name = "tetoesterkomosas_cookie_consent"

function CookieConsent(props) {
    const [consent, setConsent] = useState(localStorage.getItem(cookie_consent_variable_name));
    const [showCookieConsent, setShowCookieConsent] = useState(false)

    useEffect(() => {
        if (!consent) {
            setShowCookieConsent(true)
        } else {
            if (consent === "accepted") {
                ReactGA.initialize(GA_MEASUREMENT_ID);
                ReactGA.send({ hitType: "pageview", page: window.location.pathname });
            }
        }
    }, [consent]);

    const setCookieConsent = (value) => {
        localStorage.setItem(cookie_consent_variable_name, value)
        setConsent(value)
        setShowCookieConsent(false)
    }


    if (!showCookieConsent) {
        return <div className={"cookie-icon-container"}>
            <div title={"Süti tájékoztató"} className={"cookie-icon " + (consent === "accepted" ? "accepted" : "refused")} onClick={() => setShowCookieConsent(true)}/>
        </div>
    }

    return <div className={"cookies-notification-container"}>
            <div className={"cookies-notification"}>
                <div className={"title"}>Süti tájékoztató</div>
                <div className={"description"}>
                    Ez a weboldal sütiket és hasonló technológiákat használ annak érdekében, hogy javítsa a felhasználói élményt, személyre szabja a tartalmakat, elemezze a forgalmat, valamint statisztikai és marketing célból adatokat gyűjtsön. A sütik használatához az Ön hozzájárulása szükséges, amelyet bármikor visszavonhat vagy módosíthat.
                </div>
                <div className={"actions"}>
                    <button className={"accept"} onClick={() => setCookieConsent("accepted")}>Elfogadás</button>
                    <button className={"refuse"} onClick={() => setCookieConsent("refused")}>Elutasítás</button>
                </div>
            </div>
        </div>
}

export default CookieConsent;